import { Component, EventEmitter, Inject, Input, OnInit, Output, OnDestroy } from '@angular/core';
import _ from 'lodash';
@Component({
  standalone: false,
  selector: 'button-radio-group',
 templateUrl: '../app/form-controls/button-radio-group/button-radio-group.view.html',
  styleUrls:['../app/form-controls/button-radio-group/button-radio-group.style.css']
})
export class ButtonRadioGroup implements OnInit, OnDestroy {

    @Input() defaultSelectedOption:any = {};
    @Input() controlId:any = "buttonRadioGroup";
    @Input() labelProperty: string = "";
    @Input() valueProperty: any = null;
    @Input() selectedOption:any = this.defaultSelectedOption;
    @Input() options: any[] = [];
    @Input() disabled: boolean = false;

    @Output() onOptionChange = new EventEmitter<any>();
    
    constructor() { }

    ngOnInit(): void {
        
    }

    ngOnDestroy(): void {
        this.onOptionChange.complete();
    }

    onChange(option: any): void {
        this.selectedOption = option;
        this.onOptionChange.emit(this.selectedOption);
    }
}